import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { ProfileStatusBadge } from "../../ProfileStatusBadge";
import { documentListItem, documentContent } from "./style_vanilla.css";
import { DocumentListProps } from "./types";

export const DocumentLists: React.FC<DocumentListProps> = ({ documentDetails }) => {
  return (
    <Flex flexDirection="column">
      {documentDetails.map((document, index) => (
        <Flex
          key={index}
          className={documentListItem}
          onClick={document.onClick}
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Flex flexDirection="column" gap={Sizes.XS} flex="1" className={documentContent}>
            <Text variant="regular-xl">{document.title}</Text>
            <Text variant="secondary-sm">{document.description}</Text>
            {document.lastUploadedDate && (
              <Text variant="secondary-sm">Last uploaded on {document.lastUploadedDate}</Text>
            )}
          </Flex>
          <Flex alignItems="center" gap={Sizes.SM} flexShrink={0}>
            {document.status && <ProfileStatusBadge status={document.status} />}
            <Icon type="chevron-right" color={Colors.Neutral800} />
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};
